// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"355":"portal","873":"manager"}[chunkId] + "." + {"355":"60fcaaf7","873":"18714f9c"}[chunkId] + ".css";
};